<div class="chips-selector">
  @for (option of viewOptions; track option) {
    <button
      type="button"
      class="chip-button"
      [class.selected]="option.selected"
      [class.disabled]="option.disabled"
      (click)="toggle(option)">
      {{ option.label }}
    </button>
  }
</div>
